import React from "react";
import CRUDAdmin from "../../components/admin/CRUDAdmin";

export default function Blog() {
  return (
    <CRUDAdmin
      title="Blog"
      subtitle="Journal articles on the website."
      endpoint="/admin/blog"
      testIdPrefix="blog"
      defaults={{ published: false }}
      columns={[
        { title: "Title", render: r => <div className="serif text-lg">{r.title}</div> },
        { title: "Tag", key: "tag" },
        { title: "Published", render: r => r.published ? "Yes" : "Draft" },
      ]}
      fields={[
        { name: "title", label: "Title", full: true },
        { name: "slug", label: "Slug" },
        { name: "tag", label: "Tag" },
        { name: "excerpt", label: "Excerpt", type: "textarea", full: true },
        { name: "body", label: "Body (Markdown / HTML)", type: "textarea", full: true },
        { name: "cover_url", label: "Cover Image", type: "media", full: true },
        { name: "published", label: "Publish on website", type: "checkbox" },
      ]}
    />
  );
}
